<template>
  <tbody>
    <tr v-for="item in items" :key="item.Id" :class="rowMeta && rowMeta.rowClass(item)">

      <!-- FIELDS -->
      <td v-for="column in columnMeta.items"
        :key="column.fieldId"
        :class="{
          'has-text-right': hasTextRight(column),
          'date-field': column.dataType === 'date',
          'long-text': column.fieldId === 'internalNote' || column.fieldId === 'invoiceNote'}">

        <!-- MAIL TO -->
        <template v-if="column.actionType === 'mailto'">
          <a :href="'mailto:' + item[column.fieldId]">{{ item[column.fieldId] }}</a>
        </template>

        <!-- FIELD ACTION -->
        <template v-else>
          <span v-on="{ click: () => column.actionType === 'fieldAction' ? fieldAction(column.action, item) : null }" :class="{ 'is-table-link': column.actionType === 'fieldAction'}">
            <span v-if="column.iconClass" :class="column.iconClass"></span>
            <template v-if="column.dataType === 'bool'">
              <input type="checkbox" class="switch is-rounded has-no-animations" :checked="item[column.fieldId]">
              <label class="has-no-animations"></label>
            </template>
            <span v-else>{{ displayData(column, item[column.fieldId]) }}</span>
          </span>
        </template>

      </td>

      <!-- ROW ACTIONS -->
      <template v-if="actionMeta || showContextMenu">
        <td class="has-text-right" style="white-space: nowrap">
          <template v-if="actionMeta">
            <template v-for="action in actionMeta.items">
              <template v-if="typeof (action.showCondition) !== 'function' || action.showCondition(item)">
                <button
                  class="button is-small"
                  :key="action.action"
                  :disabled="typeof (action.disableCondition) === 'function' && action.disableCondition(item)"
                  @click="rowAction(action, item)">
                  <span class="icon is-small" v-if="action.iconClass">
                    <i :class="action.iconClass"></i>
                  </span>
                  <span v-if="action.label">{{ action.label }}</span>
                </button>
              </template>
            </template>
          </template>

          <context-menu v-if="showContextMenu" :item="item"></context-menu>

        </td>
      </template>

      <!-- <template v-if="showContextMenu">
        <td class="has-text-right">

        </td>
      </template> -->
    </tr>
  </tbody>
</template>

<script>
import ContextMenu from '@/components/nav/ContextMenu'
import { formatNumber } from '@/helpers'

export default {
  components: {
    ContextMenu
  },
  props: {
    items: null,
    rowMeta: Object,
    columnMeta: Object,
    actionMeta: Object,
    showContextMenu: Boolean
  },
  methods: {
    rowAction (action, item) {
      this.$emit('rowAction', action.action, item)
    },
    fieldAction (action, item) {
      this.$emit('fieldAction', action, item)
    },
    hasTextRight (column) {
      switch (column.dataType) {
        case 'number':
        case 'currency':
          return true
        default:
          return false
      }
    },
    joinArray (column, array) {
      let subItems = JSON.parse(JSON.stringify(array))
      let overflow = false

      if (subItems.length > 3) {
        subItems = subItems.splice(0, 3)
        overflow = true
      }

      let ret = subItems.map(x => x[column.displayProperty]).join(', ')

      if (overflow) {
        ret += '…'
      }

      return ret
    },

    displayData (column, value) {
      let ret = ''

      if (Array.isArray(value)) {
        if (value.length === 0) {
          ret = '(inga)'
        } else {
          ret = this.joinArray(column, value)
        }
      }

      switch (column.dataType) {
        case 'date':
          if (!value) {
            ret = ''
          }
          ret = this.$moment(value).format('YYYY-MM-DD')
          break

        case 'translate':
          const translation = column.translations.filter(x => x.key === value)
          if (translation && translation[0] && translation[0].value) {
            ret = translation[0].value
          } else {
            ret = value
          }
          break

        case 'number':
          ret = formatNumber(value)
          break

        case 'currency':
          ret = formatNumber(value) + ' kr'
          break

        case 'days':
          if (parseInt(value) > 1) {
            ret = value + ' dagar'
          } else {
            ret = value + ' dag'
          }
          break

        default:
          ret = value
          break
      }

      if (column.suffix) {
        ret += ' ' + column.suffix
      }

      return ret
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  font-size: 1.3em;
}
.is-table-link {
  color: black;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.date-field {
  width: 7rem;
  min-width: 7rem;
}

.long-text {
  max-width: 15rem;
}

/* DISABLE ANIMATION FOR CHECKBOXES */
.switch[type=checkbox] + label::after, .switch[type=checkbox] + label:after {
  transition: none;
}

.agile-table-red-row {
  background-color: rgba(255, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/table/AgileTableBody.vue